import { Injectable } from '@angular/core';
import { IProductDataV2 } from '@df/catalog/product/product';
import { ProductResource } from '@df/catalog/product/product.resource';
import { App } from '@df/core/app';
import { Events } from '@df/core/service/event';
import { DfModalService } from '@df/ui/modal/df-modal.service';
import groupBy from 'lodash-es/groupBy';
import without from 'lodash-es/without';
import { firstValueFrom } from 'rxjs';
import { BasketAddPromoGift } from './basket-add-promo-gift.component';

@Injectable({
    providedIn: 'root'
})
export class BasketAddPromoGiftService {
    constructor(
        private productResource: ProductResource,
        private dfModalService: DfModalService,
        private events: Events,
        private app: App
    ) {}

    async getPromoProduct(amastyPromoGiftProducts: Object): Promise<string | number | undefined> {
        if (amastyPromoGiftProducts) {
            const giftProductsIds = Object.keys(amastyPromoGiftProducts) as unknown as number[];
            if (giftProductsIds.length > 0) {
                const result = await this.loadProducts(giftProductsIds);
                if (result.length) {
                    await this.dfModalService.open(undefined, BasketAddPromoGift.id, undefined, { giftItems: result });
                    const selectedGift = await firstValueFrom(this.events.on(BasketAddPromoGift.EventAddGift));
                    if (selectedGift) {
                        await firstValueFrom(this.app.customer.basket.basketUpdateSubject);
                        return selectedGift;
                    }
                }
            }
        }
        return;
    }

    private async loadProducts(giftProductsIds: number[]): Promise<BasketAddPromoGift.IGiftProduct[]> {
        const allProducts = (await this.productResource.loadAllIds(giftProductsIds, 2, { safe: true })).filter(p => p.isSalable());
        const withoutParent = allProducts.filter(p => !(p.data as IProductDataV2).parent) || [];
        const groupedProducts = groupBy(without(allProducts, ...withoutParent), 'data.parent');
        const parentsIds = Object.keys(groupedProducts)
            .map(key => Number(key))
            .filter(id => !!id);
        const parents = await this.productResource.loadAllIds(parentsIds, 2, { safe: true });

        // if only one option select this poroduct
        const giftProducts: BasketAddPromoGift.IGiftProduct[] = await parents.map(p => ({
            parent: p,
            simpleProducts: groupedProducts[p.id],
            selectedProductId: undefined
        }));

        if (withoutParent.length > 0) {
            giftProducts.push(...withoutParent.map(p => ({ parent: p, simpleProducts: [], selectedProductId: p.id })));
        }

        return giftProducts;
    }
}
